import { CSSProperties } from 'react';
import * as React from 'react';
import {
  svgWidthInRem,
  tableRowHeightInRem,
  iconButtonWidthInRem,
  iconButtonMidpointX,
  iconButtonMidpointY,
  iconButtonOffset,
} from './ButtonWithTreeLines';

export const TreeLineModes = Object.freeze({
  Default: 0, // |-
  Vertical: 1, // |
  L: 2, // L
  UpsideDownL: 3,
  Top: 4,
  Right: 5,
  Bottom: 6,
  None: 7,
});

export function showTop(mode: TreeLineModes): boolean {
  return (
    mode === TreeLineModes.Default ||
    mode === TreeLineModes.L ||
    mode === TreeLineModes.Vertical ||
    mode === TreeLineModes.Top
  );
}

export function showRight(mode: TreeLineModes): boolean {
  return (
    mode === TreeLineModes.Default ||
    mode === TreeLineModes.L ||
    mode === TreeLineModes.UpsideDownL ||
    mode === TreeLineModes.Right
  );
}

export function showBottom(mode: TreeLineModes): boolean {
  return (
    mode === TreeLineModes.Default ||
    mode === TreeLineModes.UpsideDownL ||
    mode === TreeLineModes.Vertical ||
    mode === TreeLineModes.Bottom
  );
}

interface TreeLineProps {
  mode: TreeLineModes;
  level: number;
}

export const treeLineStyle: CSSProperties = {
  stroke: '#d5dbdb',
  strokeWidth: 1,
  vectorEffect: 'non-scaling-stroke',
};

const TreeLine = ({ mode, level }: TreeLineProps) => {
  return (
    <div
      className="ui-util-mv-i-s"
      style={{
        left: (iconButtonOffset + 2*level)+`rem`,
        top: `-0.5rem`,
        height: `0rem`,
        position: 'relative',
      }}
    >
      <span style={{ marginLeft: `${iconButtonWidthInRem}rem` }} />

      <svg
        style={{
          position: 'absolute',
          top: 0,
          left: `1rem`,
          right: 0,
          bottom: 0,
          width: `${svgWidthInRem}rem`,
          height: `${tableRowHeightInRem}rem`,
        }}
        viewBox={`0 0 ${svgWidthInRem} ${tableRowHeightInRem}`}
      >
        {showTop(mode) && (
          <line
            x1={`${iconButtonMidpointX}`}
            y1="0"
            x2={`${iconButtonMidpointX}`}
            y2={`${iconButtonMidpointY}`}
            style={treeLineStyle}
          />
        )}
        {showBottom(mode) && (
          <line
            x1={`${iconButtonMidpointX}`}
            y1={`${tableRowHeightInRem}`}
            x2={`${iconButtonMidpointX}`}
            y2={`${iconButtonMidpointY}`}
            style={treeLineStyle}
          />
        )}
        {showRight(mode) && (
          <line
            x1={`${iconButtonMidpointX}`}
            y1={`${iconButtonMidpointY}`}
            x2={`${svgWidthInRem}`}
            y2={`${iconButtonMidpointY}`}
            style={treeLineStyle}
          />
        )}
      </svg>
    </div>
  );
};

export default TreeLine;



// WEBPACK FOOTER //
// ./src/components/content/table/TreeLine.jsx